import Styleguide from "@store/Framework/Types/Styleguide";
import Upload from "@store/Library/Components/Icons/Upload";
import { buttonGetFieldIconProps } from "@store/Themes/common/props/button";

const fileUpload: Styleguide["fileUpload"] = {
    defaultProps: {
        ...buttonGetFieldIconProps(Upload, "primary"),
    },
};

export default fileUpload;
